import i from "./ghl-ui.es1246.js";
import m from "./ghl-ui.es420.js";
import a from "./ghl-ui.es1420.js";
import s from "./ghl-ui.es403.js";
function u(f, t, r) {
  if (!s(r))
    return !1;
  var e = typeof t;
  return (e == "number" ? m(r) && a(t, r.length) : e == "string" && t in r) ? i(r[t], f) : !1;
}
export {
  u as default
};
